// extracted by mini-css-extract-plugin
export default {"blurEffect":"BlurEffectImage_blurEffect__vhQp2","effect":"BlurEffectImage_effect__G-9wI"};